import React from 'react';
import PropTypes from 'prop-types';

const Section = React.forwardRef(({ children }, ref) => {
  return (
    <section className="section" ref={ref}>
      <div className="limit padded" style={{ position: 'relative' }}>
        {children}
      </div>
    </section>
  );
});

Section.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.array.isRequired])
};

export default Section;
